module.exports = __webpack_public_path__ + "img/penfold_icon.2bb2c52a.png";